import { currencyCodes } from "../../../../Product/ProductTile/constants.js";
const getMiniBannerResponse = async (endpoint, orderPrice, zipcode, abortController) => {
  var _a;
  try {
    const response = await fetch(
      `${endpoint}?orderTotal=${orderPrice}&zipcode=${zipcode}`,
      {
        method: "POST",
        signal: abortController ? abortController.signal : void 0
      }
    );
    if (response.ok) {
      return response.json();
    }
  } catch (error) {
    if ((_a = abortController == null ? void 0 : abortController.signal) == null ? void 0 : _a.aborted) {
      console.info("Request getMiniBannerDetails aborted");
    } else {
      console.error("Error fetching MiniBannerDetails:", error);
    }
    return void 0;
  }
};
const getSurchargeThresholdText = (locale, msText, orderPrice, freeDeliveryOrderAmount, surchargePrice, isPickup) => {
  if (orderPrice >= freeDeliveryOrderAmount) {
    return isPickup ? msText.reachedMinimumOrderAmount : `${msText.surcharge}: ${formatPrice(locale, 0)}`;
  }
  const thresholdPrice = freeDeliveryOrderAmount - orderPrice;
  const textTemplate = isPickup ? msText.addToPickupText : msText.addToRemoveText;
  return getAddToRemoveSurchargeText(
    locale,
    textTemplate,
    thresholdPrice,
    surchargePrice
  );
};
const getAddToRemoveSurchargeText = (locale, addToRemoveSurchargeTemplate, thresholdPrice, surchargePrice) => {
  return addToRemoveSurchargeTemplate.replace("${thresholdPrice}", formatPrice(locale, thresholdPrice)).replace("${surchargePrice}", formatPrice(locale, surchargePrice));
};
const getTooltipText = (locale, msText, orderPrice, freeDeliveryOrderAmount, surchargePrice, isPickup) => {
  let tooltipStringTemplate;
  if (isPickup) {
    tooltipStringTemplate = msText.pickupTooltip;
  } else if (orderPrice >= freeDeliveryOrderAmount) {
    tooltipStringTemplate = msText.reachedMinimumOrderAmountTooltip;
  } else {
    tooltipStringTemplate = msText.tooltip;
  }
  return tooltipStringTemplate.replace(
    "${freeDeliveryOrderAmount}",
    formatPrice(locale, freeDeliveryOrderAmount, 0)
  ).replace("${surchargePrice}", formatPrice(locale, surchargePrice, 0));
};
function formatPrice(locale, price, numberOfDigits) {
  const formatter = new Intl.NumberFormat(locale, {
    currency: currencyCodes[locale],
    maximumFractionDigits: numberOfDigits,
    minimumFractionDigits: numberOfDigits,
    currencyDisplay: "symbol",
    style: "currency"
  });
  return formatter.format(price);
}
export {
  formatPrice,
  getMiniBannerResponse,
  getSurchargeThresholdText,
  getTooltipText
};
